/* ==========================================================================
   ESTILO RANCHERO — theme.js
   ========================================================================== */
(function () {
  'use strict';

  const money = (cents) => window.Shopify && window.Shopify.formatMoney
    ? window.Shopify.formatMoney(cents, window.theme.moneyFormat)
    : '$' + (cents / 100).toLocaleString('es-CL');

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---------- Sticky header shadow ---------- */
  const header = $('.site-header');
  if (header) {
    const onScroll = () => {
      const scrolled = window.scrollY > 10;
      header.classList.toggle('is-stuck', scrolled);
      document.body.classList.toggle('is-scrolled', scrolled);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Overlay helper ---------- */
  const overlay = $('.overlay');
  const openOverlay = () => overlay && overlay.classList.add('is-open');
  const closeOverlay = () => overlay && overlay.classList.remove('is-open');

  /* ---------- Mobile nav ---------- */
  const mobileNav = $('.mobile-nav');
  $$('[data-open-mobile-nav]').forEach((b) =>
    b.addEventListener('click', () => { mobileNav.classList.add('is-open'); openOverlay(); document.body.style.overflow = 'hidden'; })
  );
  const closeMobileNav = () => { if (mobileNav) mobileNav.classList.remove('is-open'); closeOverlay(); document.body.style.overflow = ''; };
  $$('[data-close-mobile-nav]').forEach((b) => b.addEventListener('click', closeMobileNav));

  /* ---------- Search modal ---------- */
  const searchModal = $('.search-modal');
  $$('[data-open-search]').forEach((b) =>
    b.addEventListener('click', () => {
      searchModal.classList.add('is-open');
      setTimeout(() => { const i = $('input', searchModal); if (i) i.focus(); }, 200);
    })
  );
  $$('[data-close-search]').forEach((b) => b.addEventListener('click', () => searchModal.classList.remove('is-open')));
  if (searchModal) searchModal.addEventListener('click', (e) => { if (e.target === searchModal) searchModal.classList.remove('is-open'); });

  /* ---------- Cart drawer ---------- */
  const cartDrawer = $('.cart-drawer');
  const openCart = () => { if (!cartDrawer) return; cartDrawer.classList.add('is-open'); openOverlay(); document.body.style.overflow = 'hidden'; };
  const closeCart = () => { if (!cartDrawer) return; cartDrawer.classList.remove('is-open'); closeOverlay(); document.body.style.overflow = ''; };
  window.EstiloRanchero = { openCart, closeCart };

  $$('[data-open-cart]').forEach((b) =>
    b.addEventListener('click', (e) => {
      if (window.theme && window.theme.cartType === 'page') return; // let link navigate
      e.preventDefault(); openCart();
    })
  );
  $$('[data-close-cart]').forEach((b) => b.addEventListener('click', closeCart));

  if (overlay) overlay.addEventListener('click', () => { closeCart(); closeMobileNav(); });

  /* ---------- Announcement bar: close + mobile rotation ---------- */
  const recalcOverlayOffset = () => {
    const header = $('.site-header--overlay');
    if (!header) return;
    let h = header.offsetHeight;
    const overlayBar = $('.announcement--overlay');
    if (overlayBar && !overlayBar.classList.contains('is-dismissed')) h += overlayBar.offsetHeight;
    document.documentElement.style.setProperty('--overlay-offset', h + 'px');
  };

  $$('.announcement').forEach((bar) => {
    const dismissKey = 'announcement-dismissed-' + bar.dataset.id;
    const closeBtn = $('.announcement__close', bar);
    if (closeBtn) {
      if (sessionStorage.getItem(dismissKey)) { bar.classList.add('is-dismissed'); recalcOverlayOffset(); }
      closeBtn.addEventListener('click', () => {
        bar.classList.add('is-dismissed');
        try { sessionStorage.setItem(dismissKey, '1'); } catch (e) {}
        recalcOverlayOffset();
      });
    }

    const track = $('.announcement__track', bar);
    if (!track || track.dataset.rotate !== 'true') return;
    const items = $$('.announcement__item', track);
    if (items.length < 2) return;

    const speed = (parseInt(track.dataset.speed, 10) || 4) * 1000;
    let index = 0;
    let timer = null;
    const show = (n) => items.forEach((el, i) => el.classList.toggle('is-active', i === n));
    const start = () => {
      if (timer) return;
      show(index);
      timer = setInterval(() => { index = (index + 1) % items.length; show(index); }, speed);
    };
    const stop = () => { if (timer) clearInterval(timer); timer = null; };

    const mq = window.matchMedia('(max-width: 680px)');
    const sync = () => (mq.matches ? start() : stop());
    mq.addEventListener('change', sync);
    sync();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeCart(); closeMobileNav(); if (searchModal) searchModal.classList.remove('is-open'); }
  });

  /* ---------- AJAX cart ---------- */
  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return res.json();
  }

  function updateCartCount(count) {
    $$('.cart-count').forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function renderCart(cart) {
    updateCartCount(cart.item_count);
    const itemsEl = $('.cart-drawer__items');
    const footEl = $('.cart-drawer__foot');
    const emptyEl = $('.cart-drawer__empty');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.style.display = 'flex';
      if (footEl) footEl.style.display = 'none';
      const shipEl = $('.cart-drawer__ship'); if (shipEl) shipEl.style.display = 'none';
      return;
    }
    if (emptyEl) emptyEl.style.display = 'none';
    if (footEl) footEl.style.display = 'block';

    itemsEl.innerHTML = cart.items.map((item) => `
      <div class="cart-item" data-key="${item.key}">
        <a href="${item.url}" class="cart-item__img"><img src="${item.image ? item.image.replace(/(\.[^.]*)$/, '_120x120$1') : ''}" alt="${item.product_title}" width="72" height="72"></a>
        <div>
          <div class="cart-item__title">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-item__qty" data-key="${item.key}">
            <button data-qty-change="-1" aria-label="Restar">−</button>
            <input type="text" value="${item.quantity}" data-qty-input readonly>
            <button data-qty-change="1" aria-label="Sumar">+</button>
          </div>
          <button class="cart-item__remove" data-remove="${item.key}">Eliminar</button>
        </div>
        <div class="cart-item__price">${money(item.final_line_price)}</div>
      </div>`).join('');

    const subtotalEl = $('.cart-drawer__subtotal-value');
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    renderShippingBar(cart.total_price);
    bindCartItemEvents();
  }

  function renderShippingBar(total) {
    const shipEl = $('.cart-drawer__ship');
    if (!shipEl || !window.theme || !window.theme.freeShipEnabled) return;
    const threshold = window.theme.freeShipThreshold * 100;
    shipEl.style.display = 'block';
    const remaining = threshold - total;
    const pct = Math.min(100, (total / threshold) * 100);
    const msg = $('.cart-drawer__ship-msg');
    const bar = $('.cart-drawer__ship .bar span');
    if (bar) bar.style.width = pct + '%';
    if (msg) {
      msg.textContent = remaining <= 0
        ? '🎉 ¡Tienes envío gratis!'
        : `Te faltan ${money(remaining)} para envío gratis`;
    }
  }

  function bindCartItemEvents() {
    $$('[data-remove]').forEach((b) =>
      b.addEventListener('click', () => changeItem(b.dataset.remove, 0))
    );
    $$('.cart-item__qty').forEach((wrap) => {
      const key = wrap.dataset.key;
      const input = $('[data-qty-input]', wrap);
      $$('[data-qty-change]', wrap).forEach((btn) =>
        btn.addEventListener('click', () => {
          const next = Math.max(0, parseInt(input.value, 10) + parseInt(btn.dataset.qtyChange, 10));
          changeItem(key, next);
        })
      );
    });
  }

  async function changeItem(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    renderCart(await res.json());
  }

  async function addToCart(id, quantity = 1, btn) {
    const original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = '<span class="spinner"></span> Agregando…'; }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: Number(quantity) })
      });
      if (!res.ok) throw new Error('add-failed');
      const cart = await fetchCart();
      renderCart(cart);
      if (window.theme && window.theme.cartType === 'page') { window.location.href = '/cart'; return; }
      openCart();
      if (btn) btn.innerHTML = '✓ Agregado';
    } catch (e) {
      if (btn) btn.innerHTML = 'Error, reintenta';
    } finally {
      if (btn) setTimeout(() => { btn.disabled = false; btn.innerHTML = original; }, 1400);
    }
  }

  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest('[data-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      const id = addBtn.dataset.addToCart;
      const qtyInput = addBtn.closest('form') ? $('[name="quantity"]', addBtn.closest('form')) : null;
      const qty = qtyInput ? qtyInput.value : 1;
      addToCart(id, qty, addBtn);
    }
  });

  // Init cart count on load
  fetchCart().then(renderCart).catch(() => {});

  /* ---------- Product carousel arrows ---------- */
  $$('.products-carousel').forEach((carousel) => {
    const track = $('.product-track', carousel);
    const prev = $('.carousel-arrow--prev', carousel);
    const next = $('.carousel-arrow--next', carousel);
    if (!track) return;
    const step = () => track.querySelector('.product-card') ? track.querySelector('.product-card').offsetWidth + 20 : 240;
    const update = () => {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step() * 2, behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Reviews slider ---------- */
  $$('[data-reviews]').forEach((slider) => {
    const track = $('.reviews__track', slider);
    const dotsWrap = $('.reviews__dots', slider);
    const slides = $$('.review', slider);
    if (!track || slides.length < 2) return;
    let index = 0;
    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.setAttribute('aria-label', 'Reseña ' + (i + 1));
      if (i === 0) dot.classList.add('is-active');
      dot.addEventListener('click', () => go(i));
      dotsWrap.appendChild(dot);
    });
    const dots = $$('button', dotsWrap);
    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      dots.forEach((d, di) => d.classList.toggle('is-active', di === index));
    }
    let timer = setInterval(() => go(index + 1), 5500);
    slider.addEventListener('mouseenter', () => clearInterval(timer));
    slider.addEventListener('mouseleave', () => { timer = setInterval(() => go(index + 1), 5500); });
  });

  /* ---------- Scroll reveal ---------- */
  if (window.theme && window.theme.animations && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    $$('[data-reveal]').forEach((el) => io.observe(el));
  } else {
    $$('[data-reveal]').forEach((el) => el.classList.add('is-visible'));
  }

  /* ---------- Quantity selectors (generic) ---------- */
  $$('.qty-selector').forEach((wrap) => {
    const input = $('input', wrap);
    $$('button', wrap).forEach((btn) =>
      btn.addEventListener('click', () => {
        const dir = btn.dataset.dir === 'down' ? -1 : 1;
        input.value = Math.max(1, parseInt(input.value, 10) + dir);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      })
    );
  });

  /* ---------- Product gallery thumbs ---------- */
  const gallery = $('.product-gallery');
  if (gallery) {
    const mainImg = $('.product-gallery__main img', gallery);
    $$('.product-gallery__thumbs button', gallery).forEach((thumb) =>
      thumb.addEventListener('click', () => {
        const full = thumb.dataset.full;
        if (full && mainImg) mainImg.src = full;
        $$('.product-gallery__thumbs button', gallery).forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      })
    );
  }

  /* ---------- Product variant selection ---------- */
  const productForm = $('[data-product-form]');
  if (productForm) {
    const variantData = JSON.parse($('[data-variant-json]', productForm).textContent);
    const idInput = $('[data-variant-id]', productForm);
    const priceEl = $('[data-product-price]');
    const addBtn = $('[data-add-to-cart]', productForm);
    function currentOptions() {
      return $$('.product-option', productForm).map((opt) => {
        const checked = $('input:checked', opt) || $('select', opt);
        return checked ? checked.value : null;
      });
    }
    function updateVariant() {
      const selected = currentOptions();
      const match = variantData.find((v) => v.options.every((o, i) => o === selected[i]));
      if (!match) return;
      idInput.value = match.id;
      if (addBtn) addBtn.dataset.addToCart = match.id;
      if (priceEl) priceEl.innerHTML = money(match.price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? (window.theme.strings.addToCart) : (window.theme.strings.soldOut);
      }
    }
    $$('.product-option input, .product-option select', productForm).forEach((el) =>
      el.addEventListener('change', updateVariant)
    );
  }
})();
